import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';

const SortedHeaderComponent = ({
  sortBy,
  sortOrder,
  onSort
}) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell>
          <TableSortLabel
            active={sortBy === 'id'}
            direction={sortBy === 'id' ? sortOrder : 'asc'}
            onClick={() => onSort('id')}
          >
            <b>No.</b>
          </TableSortLabel>
        </TableCell>

        <TableCell>
          <TableSortLabel
            active={sortBy === 'entity'}
            direction={sortBy === 'entity' ? sortOrder : 'asc'}
            onClick={() => onSort('entity')}
          >
            <b>Name</b>
          </TableSortLabel>
        </TableCell>

        <TableCell>
          <TableSortLabel
            active={sortBy === 'country'}
            direction={sortBy === 'country' ? sortOrder : 'asc'}
            onClick={() => onSort('country')}
          >
            <b>Country</b>
          </TableSortLabel>
        </TableCell>

        <TableCell>
          <TableSortLabel
            active={sortBy === 'clientType'}
            direction={sortBy === 'clientType' ? sortOrder : 'asc'}
            onClick={() => onSort('clientType')}
          >
            <b>Client Type</b>
          </TableSortLabel>
        </TableCell>

        <TableCell><b>Director/UBO</b></TableCell>

        <TableCell>
          <TableSortLabel
            active={sortBy === 'finalRisk'}
            direction={sortBy === 'finalRisk' ? sortOrder : 'asc'}
            onClick={() => onSort('finalRisk')}
          >
            <b>Risk Rating</b>
          </TableSortLabel>
        </TableCell>

        <TableCell>
          <TableSortLabel
            active={sortBy === 'status'}
            direction={sortBy === 'status' ? sortOrder : 'asc'}
            onClick={() => onSort('status')}
          >
            <b>Action</b>
          </TableSortLabel>
        </TableCell>

        <TableCell>
          <TableSortLabel
            active={sortBy === 'zohoStatus'}
            direction={sortBy === 'zohoStatus' ? sortOrder : 'asc'}
            onClick={() => onSort('zohoStatus')}
          >
            <b>Sign Status</b>
          </TableSortLabel>
        </TableCell>

        <TableCell><b>Document</b></TableCell>
        <TableCell><b>Send</b></TableCell>

        <TableCell>
          <TableSortLabel
            active={sortBy === 'createdOn'}
            direction={sortBy === 'createdOn' ? sortOrder : 'asc'}
            onClick={() => onSort('createdOn')}
          >
            <b>Date of Creation</b>
          </TableSortLabel>
        </TableCell>

        <TableCell><b>Edit</b></TableCell>
      </TableRow>
    </TableHead>
  );
};

export default SortedHeaderComponent;
